module.exports = __webpack_public_path__ + "static/avatar_adeyemo-fcef8b37246473632d62cf10018ef227.png";